import { combineReducers } from 'redux';
import banners, { fetchBanners, fetchCarouselSecond } from './bannerReducer.js';
import links, { startLinkCountTimer, stopLinkCountTimer } from './linkReducer.js';

export const actions = {
  fetchBanners,
  fetchCarouselSecond,
  startLinkCountTimer,
  stopLinkCountTimer,
};

export default combineReducers({
  banners,
  links,
});



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/reducers/index.js
 **/